import { render } from "./Comment.vue.js?vue&type=template&id=c93aecb8!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Comment.vue?vue&type=template&id=c93aecb8"
import script from "./Comment.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Comment.vue?vue&type=script&lang=js"
export * from "./Comment.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Comment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/comment-page/Comment.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c93aecb8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c93aecb8', __exports__)) {
    api.reload('c93aecb8', __exports__)
  }
  
  module.hot.accept("./Comment.vue.js?vue&type=template&id=c93aecb8!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Comment.vue?vue&type=template&id=c93aecb8", () => {
    api.rerender('c93aecb8', render)
  })

}


export default __exports__